module.exports = __webpack_public_path__ + "img/sidebar_frauenbundesliga_202627.bb8f2911.png";